const endpointHealthConfig = {
    fhirVersion: "4.0.1",
    clientId: "smart-app",
    scopes: "launch openid fhirUser patient/*.read encounter/*.read communication/*.read offline_access",
    //launch openid fhirUser patient/*.read encounter/*.read communication/*.read offline_access",
    supportsBatch: false,
    welcomeMessage: "Welcome EndpointHealth Sandbox!",
    logo: "/images/logos/smart-logo.png",
    iss: "http://localhost:4004/hapi-fhir-jpaserver/fhir/"
};

export default endpointHealthConfig;